import OrganizationSelector from './OrganizationSelector';

export default OrganizationSelector;
